jQuery(document).ready(function () {
    var futuresNavLinks = $("#futureMarketOverview div .nav li > a");
    futuresNavLinks.each(function () {
        var href = $(this).attr('href').replace("&#futureMarketOverview", "");
        console.log(href);
        $(this).attr('href', href);
    });

    // main contact number
    // var number = $('.global-nav .phone-number span').text();
    // var numberFormatted = number.replace(/\D/g, '');
    // $('.global-nav .phone-number span').wrapInner('<a href="tel:' + numberFormatted + '"></a>');

    // function formatPhone() {
    //     var number = $(this).text();
    //     var numberFormatted = number.replace(/\D/g, '');
    //     $(this).wrapInner('<a href="tel:' + numberFormatted + '"></a>');
    // }

    if ($('.tabs').length) {
        $('.tabs .tab-con').prepend('<div class="tab-toggle"></div>');
        $('.tab-toggle').click(function () {
            $(this).toggleClass('toggled');
            $(this).next('.tab-list').toggleClass('open');
            $('.tab-list a').click(function () {
                $('.tab-list.open').removeClass('open');
                $('.tab-toggle').removeClass('toggled');
            });
        });
    }

    $.fn.formatPhone = function () {
        var phone = this;
        var phoneNumber = phone.text();
        var phoneNumberFormatted = phoneNumber.replace(/\D/g, '');
        phone.wrapInner('<a href="tel:' + phoneNumberFormatted + '"></a>');
    }
    $('.global-nav .phone-number span').formatPhone();
    $('.Header-midrow .phone-number span').formatPhone();
    $('.nav.navbar-nav .phone-number span').formatPhone();

    var OffsetFromTop = 0;
    $(function () {
        var stickyElement = '#MainNav',
            bottomElement = '.Foot';
        if ($(stickyElement).length) {
            $(stickyElement).each(function () {
                var fromTop = $(this).offset().top,
                    fromBottom = $(document).height() - ($(this).offset().top + $(this).outerHeight()),
                    stopOn = $(document).height() - ($(bottomElement).offset().top) + ($(this).outerHeight() - $(this).height());
                if ((fromBottom - stopOn) > 200) {
                    $(this).css('width', $(this).width()).css('top', 0).css('position', '');
                    $(this).affix({
                        offset: {
                            top: fromTop - OffsetFromTop,
                            bottom: stopOn
                        }
                    }).on('affix.bs.affix', function () { $(this).css('top', OffsetFromTop + 'px').css('position', ''); });
                }
                $(window).trigger('scroll');
            });
        }

    });
    $('body').scrollspy({
        offset: OffsetFromTop
    });

    //Click link to anchor with Smooth scroll and offset sticky header
    $('a[href*="#"]:not([href="#"]):not([data-toggle="tab"])').click(function () {
        var offset = -200;
        var offsetMobile = -175;
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');            
            if (target.length) {
                if ($(window).width() < 991) {
                    $('html, body').animate({
                        scrollTop: target.offset().top + offsetMobile
                    }, 1000);
                    return false;
                } else {
                    $('html, body').animate({
                        scrollTop: target.offset().top + offset
                    }, 1000);
                    return false;
                }
            }
        }
    });

    if ($('.top-links ul').length) {
        console.log('its there');
        $('.top-links ul').next('.phone-number').wrap('<li class="phone-number-item">');
        $('li.phone-number-item').appendTo('.top-links ul');
    }

    if ($('.global-nav .top-links').length == 1) {
        $('.global-nav .top-links').addClass('full-width');
    }

    // if ($('.top-links .phone-number a:empty').length) {
    //     $('.top-links .phone-number').remove();
    // }

    // if ($('.top-links .phone-number span:empty').length) {
    //     $('.top-links .phone-number').remove();
    // }

    // $('button.nav-toggle').on('click', function (item) {
    //     var $target = $(item.currentTarget);
    //     $target.find('i').toggleClass('fa-caret-right').toggleClass('fa-caret-down');
    //     var $dd = $target.next('.dropdown-menu');
    //     $dd.toggleClass('open');
    // });

    //Convert phone number text to tel links
    $(document).ready(function () {
        var regex = /(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}/;
        //Find phone links inside paragraphs and unwrap them, but not if they have a class of btn
        // if ($('.DnnModule-DNN_HTML p > a[href^=tel]:not(".btn"), footer p > a[href^=tel]:not(".btn")').length) {
        //   $('.DnnModule-DNN_HTML p > a[href^=tel]:not(".btn"), footer p > a[href^=tel]:not(".btn")').contents().unwrap();
        // }
        //Wrap telephone number text in tel links
        $('.DnnModule-DNN_HTML p, footer p').each(function () {
            $(this).contents().each(function () {
                if (this.nodeType === 3 || $(this).prop("tagName") == 'SPAN' || $(this).prop("tagName") == 'BIG') {
                    var text = $(this).text();
                    if (regex.test(text)) {
                        var match = text.match(regex);
                        var myHTML = text.replace(match[0], "<a href=tel:" + phoneFormat(match[0]) + ">" + match[0] + "</a>");
                        if (myHTML.includes("BOARD")) {
                            console.log("myHtml = " + myHTML);
                        }
                        //if ($(this).prop("tagName") == 'SPAN') {
                        //    myHTML = "<span>" + myHTML + "</span>";
                        //}
                        //if ($(this).prop("tagName") == 'BIG') {
                        //    myHTML = "<big>" + myHTML + "</big>";
                        //}
                        $(this).html(myHTML);
                    }
                }
            });
        });

        function phoneFormat(input) {
            input = input.replace("(", "");
            input = input.replace(")", "");
            input = input.replace("-", "");
            input = input.replace(" ", "");
            return input;
        }
    });

    // filter resources
    $('.filter-products').on('click', function () {
        if ($(this).hasClass('open')) {
            $('.filter-products').removeClass('open');
            $('.filter-products + .checkbox-list').slideUp();
        } else {
            $('.filter-products').addClass('open');
            $('.filter-products + .checkbox-list').slideDown();
        }
    });
    // filter resources
    $('.lrs-rc .btn-filters').on('click', function () {
        console.log('clicked');
        if ($('.lrs-rc .filters').hasClass('visible')) {
            $('.lrs-rc .btn-filters').removeClass('visible');
            $('.lrs-rc .filters').removeClass('visible');
        } else {
            $('.lrs-rc .btn-filters').addClass('visible');
            $('.lrs-rc .filters').addClass('visible');
        }
    });
    $('button.nav-toggle').on('click', function (item) {
        var $target = $(item.currentTarget);
        $target.find('i').toggleClass('fa-caret-up').toggleClass('fa-caret-down');
        var $dd = $target.next('.dropdown-menu');
        $dd.toggleClass('open');
    });

    $('.searchbar-toggle').click(function () {
        $('body').toggleClass('search-reveal');
    });

    $('.navbar-nav li > button').click(function () {
        // $(this).parent().toggleClass('open');
    });

    $(".SocialLinks ul li span:empty").parent().hide();

    // Sidebar Nav Toggle for Mobile

    $(".sidebar .dropdown-toggle").click(function () {
        $(this).toggleClass('toggled');
        $(this).next('.sidebar-nav').toggleClass('open');
    });

    //Alt Nav functionality
    // if ($('.altnav').length) {
    //     $('.global-nav .gm-dtn-weather-widgets').remove();
    // } else {
    //     $('.altnav-weather').remove();
    // }

    if ($('.altnav').length) {
        if ($(window).width() < 991) {
            $('.altnav-weather').remove();
        } else {
            window.addEventListener("load", function () {
                $('.global-nav .gm-dtn-weather-widgets').remove();
            });
        }
    } else {
        $('.altnav-weather').remove();
    }

    if ($(".cta-banner.background-image, .cta-banner-wide.background-image").length) {
        $(".cta-banner.background-image figure, .cta-banner-wide.background-image figure").each(function () {
            $(this).parent().css('background-image', 'url(' + $(this).find('img').attr('src') + ')');
            $(this).find('img').remove();
        });
    }

    //Responsive Tables
    $('.main-content').responsiveTables();

    //Make full width Lists so you can click edit icon in the admin
    if ($('.personalBarContainer').length) {
        $('.cta-image-block.full-width').css('padding', '0 48px');
    }

    // banners
    if ($('body').hasClass('dnnEditState')) {
        $('.banners').cycle({
            slides: '.banner',
            speed: 600,
            manualSpeed: 350,
            fx: 'fadeout',
            manualfx: 'fadeout',
            timeout: 8000,
            pager: '.cycle-pager',
            next: '.next',
            prev: '.prev',
            swipe: true,
            swipefx: 'scrollHorz'
        });
    } else {
        $('.banners').cycle({
            slides: '.banner:not(.yes)',
            speed: 600,
            manualSpeed: 350,
            fx: 'fadeout',
            manualfx: 'fadeout',
            timeout: 8000,
            pager: '.cycle-pager',
            next: '.next',
            prev: '.prev',
            swipe: true,
            swipefx: 'scrollHorz'
        });
        // $('.banners-video').cycle('destroy');
    }

    //Set different slide on every refresh
    var slideCount = 0;

    slideCount = $('.banners').children('.cycle-slide').length;

    var thisCount = Math.floor(Math.random() * slideCount);

    if (sessionStorage['visited']) {

        if (parseInt(sessionStorage['visited']) === thisCount) {
            thisCount = (thisCount + 1);
        }
    }

    sessionStorage['visited'] = thisCount;

    $('.banners').cycle('goto', thisCount);

    // video banners
    enquire.register("screen and (max-width: 1023px)", function () {
        // $('.banner-video').each(function () {
        // $('iframe').remove();
        // });
    }).register("screen and (min-width: 1024px)", function () {
        $('.banner-video').each(function () {
            var time = $(this).attr('data-duration');
            var timeParts = time.toString().split(':');
            var milliseconds = $((timeParts[0] * 60 * 1000) + (timeParts[1] * 1000));
            $(this).attr('data-cycle-timeout', milliseconds[0]);
            $(this).removeAttr('data-duration');
        });
        $('.banners-video').on('cycle-after', function (e, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
            var nextSlide = $(incomingSlideEl);
            var previousSlide = $(outgoingSlideEl);
            if (nextSlide.hasClass('video')) {
                var iframeSrc = $('iframe', this).attr('src');
                var iframeID = $('iframe', this).attr('id');
                var autoplay = iframeSrc.replace('?controls=0&rel=0&loop=1', '?controls=0&autoplay=1&mute=1&rel=0&loop=1');
                $('iframe', this).attr('src', autoplay);
            }
            if (previousSlide.hasClass('video')) {
                var iframeSrc = $('iframe', this).attr('src');
                var autoplay = iframeSrc.replace('?controls=0&autoplay=1&mute=1&rel=0&loop=1', '?controls=0&rel=0&loop=1');
                $('iframe', this).attr('src', autoplay);
            }
        });
    });
    $('.banners-video-pause').on('click', function () {
        $(this).removeClass('visible');
        $('.banners-video').cycle('pause');
        $('.banners-video-play').addClass('visible');
        $('.banners-video-pause').removeClass('visible');
    });
    $('.banners-video-play').on('click', function () {
        $(this).removeClass('visible');
        $('.banners-video').cycle('resume');
        $('.banners-video-pause').addClass('visible');
        $('.banners-video-play').removeClass('visible');
    });

    // photo gallery
    if (!$('body').hasClass('dnnEditState')) {
        // $('.gallery .photo').each(function () {
        // var imageURL = $('img', this).attr('src');
        // $('.background', this).css('background-image', imageURL);
        // });
        $('.gallery').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            asNavFor: '.gallery-pager',
            adaptiveHeight: true,
            prevArrow: '<div class="nav-prev"><button type="button" class="slick-prev" aria-label="Previous Photo"><i class="fas fa-angle-left"></i></button></div>',
            nextArrow: '<div class="nav-next"><button type="button" class="slick-next" aria-label="Next Photo"><i class="fas fa-angle-right"></i></button></div>'
        });
        $('.gallery-pager').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: '.gallery',
            arrows: false,
            centerMode: true,
            focusOnSelect: true
        });
    }

    function isItIE() {
        user_agent = navigator.userAgent;
        var is_it_ie = user_agent.indexOf("MSIE ") > -1 || user_agent.indexOf("Trident/") > -1;
        return is_it_ie;
    }
    if (isItIE()) {
        console.log('It is Internet Explorer');
        $('.ie-alert').show();
    }
    $('.ie-alert .close').on('click', function () {
        $('.ie-alert').hide();
    });
    $(window).scroll(function () {
        var alertTop = $('.ie-alert').height();
        if ($(this).scrollTop() >= alertTop) {
            $('.ie-alert').hide();
        }
    });

    // energy catalog
    $('.energy-catalog ul.product-resources a').each(function () {
        var file = $(this).attr('href');
        var ext = file.split('.').pop();
        if (ext === 'pdf') {
            $(this).parent().addClass('file-pdf');
        } else if (ext === 'xls' || ext === 'xlsx') {
            $(this).parent().addClass('file-excel');
        } else if (ext === 'doc' || ext === 'docx') {
            $(this).parent().addClass('file-word');
        } else { }
    });

    $.fn.PhoneNumbers({
        linkColor: '#cd0e13',
        linkDecoration: 'none',
        mobileOnly: false
    });

    // online store modal content
    var imageModalID;
    var imageModal;
    $('.online-store .open-image-modal').each(function () {
        imageModal = $(this).html();
        console.log(imageModal);
        $(this).next('.modal.modal-image').find('.ph-img').replaceWith(imageModal);
    });

    // phone numbers
    $('span[itemprop="telephone"] > a').each(function () {
        var phoneText = $(this).text();
        var phoneLink = $(this).attr('href');
        var phoneFormatted = phoneLink.replace(RegExp('tel:', 'g'), '').split('+').join('').replace(RegExp('-', 'g'), '');
        $(this).attr('href', 'tel:' + phoneFormatted);
    });

    // Locator
    // if ($('.store-locator').length) {
    //   $('body').addClass('store');
    // }

    $('.view-map').on('click', function () {
        $('.store-locator-results .results-list').toggle();
        $('body').toggleClass('map-view');
        // var center = map.getCenter();
        // google.maps.event.trigger(map, 'resize');
        // map.setCenter(center);
    });
    $('.view-list').on('click', function () {
        $('.store-locator-results .results-list').show();
        $('body').removeClass('map-view');
    });
    $('.store .store-locator .result .details').each(function () {
        var link = $(this).attr('href');
        $(this).attr('href', '#locationDetail');
        // console.log(link);
        $(this).on('click', function (e) {
            e.preventDefault();
            $('#locationDetailFrame').attr('src', link);
        });
    });
    $('#locationDetail .close-modal').on('click', function () {
        $('#locationDetailFrame').attr('src', '');
    });

    $('.store .store-locator .result .share').each(function () {
        $(this).attr('href', '#shareLocation');
    });

    $('.store .store-locator-search a.submit').each(function () {
        $(this).attr('href', '#filterResults');
    });

    // location link
    $('.store-nav [href]').each(function () {
        if (this.href == window.location.href) {
            $(this).addClass('active');
        }
    });

    //share link
    // $('.share.open-modal').on('click', function (e) {
    //   console.log('share link clicked');
    //   e.preventDefault();
    //   $('.share.open-modal').next('.modal').addClass('show-modal');
    //   $('body').addClass('modal-open');
    //   $('.modal-overlay').addClass('show-modal');
    //   $('.modal-overlay').click(function () {
    //     $('html, body').removeClass('modal-open');
    //     $(this).removeClass('show-modal');
    //     $('.modal.show-modal').removeClass('show-modal');
    //   });
    //   $('.modal .close-modal').click(function () {
    //     $('html, body').removeClass('modal-open');
    //     $('.modal.show-modal').removeClass('show-modal');
    //   });
    // });

    $('.store-nav [href]').each(function () {
        if (this.href == window.location.href.toLowerCase()) {
            $(this).addClass('active');
        }
    });

    $('.gm-style-iw-d').each(function () {
        $('a:last-child').addClass('open-modal');
    });

    function isIntoView(elem) {
        var documentViewTop = $(window).scrollTop();
        var documentViewBottom = documentViewTop + $(window).height();

        var elementTop = $(elem).offset().top;
        var elementBottom = elementTop + $(elem).height();

        return ((elementBottom <= documentViewBottom) && (elementTop >= documentViewTop));
    }

    var DTNTextBoxContainer = $('#local-weather-widget');    
    if (DTNTextBoxContainer.length > 0) {
        if (isIntoView(DTNTextBoxContainer)) {
            console.log("Is In View");
            $(".mapboxgl-ctrl-geocoder--input").css("display", "block");
        }
        $(window).scroll(function () {
            if (isIntoView(DTNTextBoxContainer)) {
                console.log("Is In View");
                $(".mapboxgl-ctrl-geocoder--input").css("display", "block");
            }
        })
    }
    // sorted tables
    $(function () {
        $('.locations').tablesorter();
    });
});


